import { jsx as i } from "react/jsx-runtime";
import { IconButton as s } from "@chakra-ui/react";
import { forwardRef as c } from "react";
const m = c((o, t) => {
  const { isFullWidth: n, ...r } = o;
  return /* @__PURE__ */ i(s, { ref: t, w: n ? "100%" : void 0, ...r });
});
m.displayName = "IconButton";
export {
  m as IconButton
};
